export const countries = [
  { flag: 'gt', name: 'Guatemala', code: '+502' },
  { flag: 'cl', name: 'Chile', code: '+56' },
  { flag: 'ar', name: 'Argentina', code: '+54' },
  { flag: 'co', name: 'Colombia', code: '+57' },
  { flag: 'us', name: 'Estados Unidos', code: '+1' },
  { flag: 'mx', name: 'México', code: '+52' },
];
